import { get, post } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

const TRACKED_EMAILS_ENDPOINT = '/members-api/oes-event-store-proxy/emails/'
const TRACKED_EMAILS_SUMMARY_ENDPOINT = '/members-api/oes-event-store-proxy/analytics/summary/'
const MESSAGE_ACCESS_ENDPOINT = '/members-api/oes-encryption-proxy/messages/'

export default () => ({
  getTrackedEmails(params = {}, companyFilter = '') {
    const url = buildURL(
      TRACKED_EMAILS_ENDPOINT,
      {
        companyFilter,
        ...params,
      },
      true
    )
    return get(url)
  },

  getTrackedEmailsSummary(timeFrame, companyFilter = '') {
    const url = buildURL(TRACKED_EMAILS_SUMMARY_ENDPOINT, { companyFilter, timeFrame })
    return get(url)
  },

  getTrackedEmailDetail(messageIdNormalized, companyFilter = '') {
    const path = `${TRACKED_EMAILS_ENDPOINT}${encodeURIComponent(messageIdNormalized)}/`
    const url = buildURL(path, { companyFilter })
    return get(url)
  },

  changeMessageAccess(access, msgGuid, companyFilter = '') {
    const url = buildURL(`${MESSAGE_ACCESS_ENDPOINT}${access}/`, { companyFilter })
    return post(url, { msgGuid })
  },
})
